/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { VpHookFormInput } from './VpHookFormInput';
import { useFormContext } from 'react-hook-form';

// styles
const boxStyles = {
  position: 'relative'
};
const skeletonStyles = {
  position: 'absolute',
  height: '40px',
  width: '100%',
  borderRadius: '5px',
  top: 0,
  left: 0
};

export const VpStripeInput = ({
  helperText,
  InputLabelProps,
  InputProps = {},
  inputProps,
  stripeElement,
  options,
  name = 'StripeInput',
  ...rest
}) => {
  const [isReady, setIsReady] = useState(false);

  const { trigger, setValue } = useFormContext();

  const onReady = () => {
    setIsReady(true);
  };

  const onChange = (e) => {
    setValue(name, e?.empty ? '' : true);
    trigger(name);
  };

  return (
    <Box sx={boxStyles}>
      {!isReady && <Skeleton animation="wave" sx={skeletonStyles} variant="rectangular" />}
      <VpHookFormInput
        onChange={onChange}
        name={name}
        required="This field is required"
        sx={{
          '& .__PrivateStripeElement': {
            top: '2px',
            position: 'relative'
          }
        }}
        fullWidth
        size="small"
        variant="outlined"
        InputLabelProps={{
          ...InputLabelProps
        }}
        inputProps={{
          ...inputProps,
          ...InputProps?.inputProps,
          component: stripeElement,
          onReady,
          options: options
        }}
        inputComponent={StripeInput}
        isNumber
        {...InputProps}
        {...rest}
      />
    </Box>
  );
};

const StripeInput = forwardRef(function StripeInput(props, ref) {
  const { component: Component, options, ...rest } = props;
  const theme = useTheme();
  const [mountNode, setMountNode] = useState(null);

  useImperativeHandle(
    ref,
    () => ({
      focus: () => mountNode?.focus()
    }),
    [mountNode]
  );

  return (
    <Component
      onReady={setMountNode}
      options={{
        ...options,
        style: {
          base: {
            fontSize: '16px',
            fontFamily: 'Roboto, sans-serif',
            '::placeholder': {
              color: theme.palette.vpColors.grey
            }
          },
          invalid: {
            color: theme.palette.error.main
          }
        }
      }}
      {...rest}
    />
  );
});



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpStripeInput.jsx